// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneCategoryFragmentDoc } from './StoneCategory.fragment.generated';
import { StoneCategoryTranslationFragmentDoc } from './StoneCategoryTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from './stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from './ClarityTranslation.fragment.generated';
import { StoneColorFragmentDoc } from './StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from './StoneColorTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from '../../nonsku/fragments/stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from '../../nonsku/fragments/stoneCrystalTranslation.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../../components/monolithImageSize.fragment.generated';
import { StoneImageFragmentDoc } from './image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../../../domain/stone/certificate.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
export const StoneFragmentDoc = `
    fragment stone on GemsApi_Stone {
  __typename
  identifier
  blackInclusion
  categoryWithInfo {
    code
    info {
      ...stoneCategory
    }
  }
  clarityWithInfo {
    code
    info {
      ...stoneClarity
    }
  }
  colorWithInfo {
    code
    info {
      ...stoneColor
    }
  }
  crystalWithInfo {
    code
    info {
      ...stoneCrystal
    }
  }
  colourShade
  crystal
  culet
  cutWithInfo {
    __typename
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  eyeClean
  fluorescenceWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  fluorescenceColour
  girdleMin
  girdleMax
  gradeWithInfo {
    code
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  growthMethod
  polishWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  shapeWithInfo {
    code
    info {
      systemCode
      samplePhoto {
        id
        url
        medium: size(name: MEDIUM) {
          ...monolithImageSize
        }
        medium_x2: size(name: MEDIUM_X2) {
          ...monolithImageSize
        }
      }
      icon {
        id
        url
      }
      translation(locale: $locale) {
        name
      }
    }
  }
  symmetryWithInfo {
    code
    info {
      abbreviation
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  shippingFromCountry
  originCountry
  length
  width
  depth
  weight
  ratio
  pavilionDepth
  pavilionAngle
  tablePercent
  depthPercent
  crownAngle
  crownHeight
  image {
    ...StoneImage
  }
  images {
    ...StoneImage
  }
  v360Url
  isMilky
  isTreated
  isCertificateVerified
  isCanadaMark
  isB2B
  isValidB2C
  isHideCertificateNumber
  isHideMeasurements
  deliveryDays
  ...gemsApiCertificate
  dtlReport {
    __typename
    url
    code
  }
  scsReport
  salePrice(currency: $currency, country: $country) {
    ...money
  }
  price
}
    `;